import { Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const SignUpContact = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  padding: 40px;
  width: 458px;

  .phone-input-container .flag-dropdown.open {
    z-index: 4;
  }

  ${DEVICE.mobile.max} {
    padding: 24px;
    width: 100%;
  }
`;

const SignUpContactForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

const SignUpContactFormGroup = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;

  ${Input.S?.Base} {
    width: calc(50% - 4px);
  }

  ${DEVICE.mobile.max} {
    flex-direction: column;

    ${Input.S?.Base} {
      width: 100%;
    }
  }
`;
const SignUpContactFooter = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

export { SignUpContact, SignUpContactFooter, SignUpContactForm, SignUpContactFormGroup };
